var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEva5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 147,
    height: 147,
    viewBox: "0 0 147 147",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_524_307)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.4283 124.308C93.8369 132.707 85.4042 139.56 75.922 140.972C74.6638 141.16 73.372 141.254 72.0817 141.254H72.0805C60.7324 141.254 49.9267 133.968 46.9462 124.308C45.2226 118.724 45.6357 112.728 48.2097 105.979C52.5025 94.7193 63.5358 82.1538 70.9783 71.9468C78.8678 82.6576 88.8857 92.043 95.1648 105.979C97.7382 112.728 98.1518 118.724 96.4283 124.308Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.0999 123.332C91.7528 130.949 84.1132 137.163 75.5238 138.443C74.3839 138.614 73.2134 138.7 72.0448 138.7H72.0436C61.7636 138.699 51.9747 132.093 49.2749 123.332C47.7137 118.269 48.0878 112.833 50.4194 106.712C54.4073 96.2422 64.2336 84.5522 71.1377 75.0742C78.0452 84.5513 88.9674 96.2404 92.9555 106.712C95.2867 112.833 95.6613 118.269 94.1 123.332H94.0999Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.8808 23.1903C93.2894 14.791 84.8567 7.93796 75.3745 6.52638C74.1163 6.33849 72.8245 6.24365 71.5342 6.24365H71.533C60.1849 6.24439 49.3792 13.5299 46.3987 23.1903C44.6752 28.7743 45.0887 34.7701 47.6622 41.5192C53.0144 55.5572 62.7467 63.2935 71.332 75.0676C79.3487 64.0789 89.8188 54.1062 94.6173 41.5192C97.1907 34.7701 97.6043 28.7743 95.8808 23.1903Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.8022 24.1302C91.4287 16.6717 83.704 10.5862 75.019 9.33256C73.8663 9.1659 72.6829 9.08154 71.5014 9.08154H71.5002C61.1053 9.08199 51.2078 15.5517 48.4779 24.1302C46.8992 29.0885 47.2775 34.4128 49.6347 40.4064C53.6671 50.6592 64.1565 62.1074 71.1377 71.3888C78.1218 62.1082 88.612 50.6611 92.6444 40.4064C95.0017 34.4128 95.3804 29.0885 93.8021 24.1302H93.8022Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7559 6.2334H45.5237C44.4473 6.2334 43.5747 7.15365 43.5747 8.28883C43.5747 9.42401 44.4473 10.3443 45.5237 10.3443H96.7559C97.8323 10.3443 98.7049 9.42401 98.7049 8.28883C98.7049 7.15365 97.8323 6.2334 96.7559 6.2334Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7559 137.428H45.5237C44.4473 137.428 43.5747 138.32 43.5747 139.419V139.419C43.5747 140.519 44.4473 141.41 45.5237 141.41H96.7559C97.8323 141.41 98.7049 140.519 98.7049 139.419V139.419C98.7049 138.32 97.8323 137.428 96.7559 137.428Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_524_307"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 146.256,
    height: 146.256,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEva5);
export default __webpack_public_path__ + "static/media/EVA_5.e68eeefef9fa9a522eb3a16a03371d70.svg";
export { ForwardRef as ReactComponent };